import { Box, Container, Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { productViewRequest } from "../../../redux/products/ProductAction";
import "../../../style/style.css";
import { StyledContainer, styles } from "../../components/formStyles";
import CustomButton from "../../constant/commonButton";
import ReusableFormFields from "../../constant/reusableFormFields";
import { APP_LINK } from "../../global/MenuItems";
import uploadImage from "../../../image/wmremove-transformed-Photorooms.jpg";
import ImagePreviewDialog from "../../constant/commonImageDialog";

const ViewProduct = () => {
  const {
    register,
    setValue,
    control,
    formState: { errors },
  } = useForm();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();
  const [selectedImage, setSelectedImage] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [open, setOpen] = useState(false);

  const productState = useSelector(
    (state) => state?.product?.viewProduct?.data || {}
  );
  const productList = productState || [];

  const inputFields = [
    {
      name: "product_code",
      label: "Sub Brand Code",
      readOnly: true,
    },
    {
      name: "brand_id",
      label: "Brand Name",
      size: "semiMedium",
      readOnly: true,
    },
    {
      name: "product_name",
      label: "Sub Brand Name",
      size: "medium",
      readOnly: true,
    },
    {
      name: "description",
      label: "Description",
      size: "semiExtraLarge",
      readOnly: true,
    },
    {
      name: "status",
      label: "Status",
      readOnly: true,
    },
  ];

  const handleCancel = () => {
    navigate(APP_LINK.PRODUCTLIST);
  };

  useEffect(() => {
    if (id) {
      dispatch(productViewRequest(id));
    }
  }, [id, dispatch]);

  useEffect(() => {
    if (productList) {
      setValue("product_code", productList?.product_code);
      setValue("brand_id", productList?.Brand?.brand_name);
      setValue("product_name", productList?.product_name);
      setValue("description", productList?.description);
      const statusLabel =
        productList?.status === 1
          ? "Active"
          : productList?.status === 0
          ? "Pending"
          : "Inactive";
      setValue("status", statusLabel);

      const imageUrl = productList?.product_image;
      setImagePreview(imageUrl ? imageUrl : []);
    }
  }, [productList, setValue]);

  const handleImageClick = (image) => {
    if (image !== uploadImage) {
      setSelectedImage(image);
      setOpen(true);
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Container>
      <form>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12} md={12} lg={6} xl={5}>
            <Box>
              <Typography
                variant="h5"
                gutterBottom
                sx={styles.title}
                className="headingTable"
              >
                <h1> Sub Brand Overview </h1>
              </Typography>
            </Box>
            <Box>
              <img
                src={imagePreview}
                alt="Product"
                width={100}
                height={150}
                style={styles.image}
                onClick={() => handleImageClick(imagePreview)}
              />
            </Box>
          </Grid>

          {/* Form section */}
          <Grid item xs={12} sm={12} md={12} lg={8} xl={8}>
            <ReusableFormFields
              inputFields={inputFields}
              control={control}
              errors={errors}
              register={register}
              setValue={setValue}
            />

            {/* Submit and Cancel Buttons */}
            <Box sx={styles.submitGap}>
              <Grid container spacing={2} item xs={12}>
                <Grid item xs={6}>
                  <CustomButton
                    text="Back"
                    size="medium"
                    onClick={handleCancel}
                    buttonStyle="StyledButton"
                  />
                </Grid>
              </Grid>
            </Box>
          </Grid>
        </Grid>
      </form>

      {/* Popup Dialog */}
      <ImagePreviewDialog
        open={open}
        onClose={handleClose}
        selectedImage={selectedImage}
      />
    </Container>
  );
};

export default ViewProduct;
